export const removeHtmlTags = (html: string): string =>
	html
		.replace(new RegExp('<!--[sS]*?--!?>', 'g'), '')
		.replace(new RegExp('</?[a-z][^>]*(>|$)', 'gi'), '')
